import { Box, Tooltip as MuiTooltip } from "@mui/material";
import React, { Component } from "react";

export default class Tooltip extends Component<any> {
  static defaultProps = {};

  render() {
    const {
      title,
      placement,
      children,
      open,
      componentsProps,
      onClose,
      disableFocusListener,
      disableHoverListener,
      disableTouchListener,
      maxWidth,
      sx,
      enterDelay,
      anchorEl,
    }: any = this.props;

    return !title ? (
      <div>{children}</div>
    ) : (
      <MuiTooltip
        title={<Box>{title}</Box>}
        open={open}
        placement={placement}
        arrow={true}
        onClose={onClose}
        disableFocusListener={disableFocusListener}
        disableHoverListener={disableHoverListener}
        disableTouchListener={disableTouchListener}
        enterDelay={enterDelay}
        sx={{ ...sx, maxWidth: maxWidth }}
        componentsProps={{
          tooltip: { sx: { maxWidth: maxWidth, ...sx } },
          ...componentsProps,
        }}
        PopperProps={
          anchorEl
            ? {
                anchorEl: anchorEl,
              }
            : {}
        }
      >
        {children}
      </MuiTooltip>
    );
  }
}
